export default __webpack_public_path__ + "static/media/mao-fechada.32d55bc0.png";